import NavigationBar from "../../components/navigationBar";
import FooterView from "../../components/footerView";
import TechnicalSEOExplainerComponent from "../../components/explainer-pages/technicalSEOExplainerComponent";


export default function TechnicalSEOExplainerPage() {


    return (
        <div>
            <NavigationBar />
            <TechnicalSEOExplainerComponent />
            <FooterView />
        </div>
    )
}